import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  Optional,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
})
export class ImageModalComponent {
  @Input()
  public imageSrc: string = this.data?.imageSrc;
  @Input()
  public descr: string = this.data?.descr;
  @Input()
  public price: string = this.data?.price;
  @Input()
  public title: string = this.data?.title;
  @Input()
  public set cropInformation(value) {
    this._cropInformation = value;
    this._setCurrentCropInformation();
  }
  public _cropInformation = [];

  public currentCropInformation = null;
  public otherImages = [];
  constructor(
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    @Optional()
    private currentModal: NgbActiveModal,
    @Optional()
    private currentBottomSheet: MatBottomSheetRef,
  ) {}
  private _setCurrentCropInformation() {
    let i = this.otherImages.indexOf(this.imageSrc);
    // i++
    this.currentCropInformation = this._cropInformation[i];

    console.log(
      'index=',
      i,
      'cropInfos=',
      this._cropInformation,
      this.imageSrc,
      this.otherImages,
    );
  }
  public isBottomSheet = false;

  public close() {
    this.currentBottomSheet?.dismiss();
    this.currentModal?.dismiss();
  }

  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767;
  }

  public changeMainImageTo(img) {
    const index = this.otherImages.indexOf(img);
    if (index == -1) {
      console.error("invalid value that doesn't exist in image array given!");
      return;
    }
    const tmp = this.imageSrc;
    this.imageSrc = img;
    //this.otherImages[index] = tmp;
    this._setCurrentCropInformation();
    this.cdr.detectChanges();
  }
}
